import tzlookup from 'tz-lookup'

/**
 * Resolves IANA timezone for coordinates entirely client-side via tz-lookup's
 * polygon dataset. No network call, no API key, no quota.
 *
 * @param {number} latitude
 * @param {number} longitude
 * @returns {Promise<string>} e.g. "America/Chicago"
 */
export async function fetchTimezoneIdFromLatLng(latitude, longitude) {
  if (
    typeof latitude !== 'number' ||
    typeof longitude !== 'number' ||
    Number.isNaN(latitude) ||
    Number.isNaN(longitude)
  ) {
    throw new Error('Invalid coordinates for timezone lookup.')
  }
  return tzlookup(latitude, longitude)
}
